/* Snowburd storefront helpers: order fields, apparel size breakdown + tier selection, price tables. */
(() => {
  const money = (cents) => '$' + (cents / 100).toFixed(2);
  const num = (s) => { const m = String(s).match(/(\d+)/); return m ? +m[1] : 0; };
  const fieldsFor = (formId) => document.querySelector(`[data-sb-fields][data-form="${formId}"]`);
  const variantsFor = (formId) => { const el = document.querySelector(`script[data-sb-variants="${formId}"]`); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };
  const optionNamesFor = (formId) => { const el = document.querySelector(`script[data-sb-options="${formId}"]`); try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; } };

  /* Quantity tier values look like "1–11 pieces", "12–23 pieces", "48+ pieces". */
  const tierFits = (label, n) => { const m = String(label).match(/(\d+)\s*(?:[–-]\s*(\d+)|\+)/); if (!m) return false; const lo = +m[1], hi = m[2] ? +m[2] : Infinity; return n >= lo && n <= hi; };

  function selectedOptions(formId) {
    const names = optionNamesFor(formId), out = {};
    const vs = document.querySelector(`variant-selects[data-section="${formId.replace('product-form-', '')}"]`) || document.querySelector('variant-selects');
    names.forEach((name, i) => {
      if (!vs) return;
      const checked = vs.querySelector(`input[data-option-name="${CSS.escape(name)}"]:checked`);
      const sel = vs.querySelectorAll('select')[i];
      out[name] = checked ? checked.value : sel ? sel.value : '';
    });
    return out;
  }

  function findVariant(formId, opts) {
    const vars = variantsFor(formId), names = optionNamesFor(formId);
    if (!vars) return null;
    return vars.find((v) => names.every((n, i) => v.options[i] === opts[n])) || null;
  }

  function pickOption(formId, name, value) {
    const vs = document.querySelector('variant-selects'); if (!vs) return;
    const input = vs.querySelector(`input[data-option-name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`);
    if (input) { if (!input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); } return; }
    const names = optionNamesFor(formId), sel = vs.querySelectorAll('select')[names.indexOf(name)];
    if (sel && sel.value !== value) { sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  function apparelState(f) {
    const formId = f.dataset.form, opts = selectedOptions(formId);
    const when = f.dataset.sizesWhen, wrap = f.querySelector('[data-sb-sizes-wrap]');
    const sizesOn = !!wrap && (!when || Object.values(opts).some((v) => String(v).includes(when)));
    if (wrap) wrap.hidden = !sizesOn;
    const ext = (f.dataset.ext || '').split(',').filter(Boolean);
    let total = 0, extCount = 0; const parts = [];
    if (sizesOn) f.querySelectorAll('[data-sb-size]').forEach((i) => { const n = Math.max(0, Math.round(+i.value || 0)); if (n) { total += n; parts.push(`${i.dataset.sbSize} ${n}`); if (ext.includes(i.dataset.sbSize)) extCount += n; } });
    else { const q = document.querySelector(`input[name="quantity"][form="${formId}"]`); total = q ? Math.max(1, +q.value || 1) : 1; }
    const out = f.querySelector('[data-sb-sizes-out]'); if (out) out.value = sizesOn ? parts.join(', ') : '';
    return { formId, opts, sizesOn, total, extCount, parts };
  }

  function syncApparel(f) {
    const st = apparelState(f), names = optionNamesFor(st.formId), tierName = names.find((n) => /quantity/i.test(n));
    const count = f.querySelector('[data-sb-count]');
    if (count && st.sizesOn) count.textContent = st.total ? `${st.total} piece${st.total === 1 ? '' : 's'}${st.extCount ? ` · ${st.extCount} in 2XL+ (+$${f.dataset.upcharge} each, added to your cart)` : ''}` : 'Enter how many of each size. The quantity and price tier update automatically.';
    if (tierName && st.total) {
      const vars = variantsFor(st.formId) || [], idx = names.indexOf(tierName);
      const label = [...new Set(vars.map((v) => v.options[idx]))].find((l) => tierFits(l, st.total));
      if (label && st.opts[tierName] !== label) pickOption(st.formId, tierName, label);
    }
    if (st.sizesOn) { const q = document.querySelector(`input[name="quantity"][form="${st.formId}"]`); if (q && st.total) q.value = st.total; }
    const qwrap = document.querySelector(`#Quantity-Form-${st.formId.replace('product-form-', '')}`) || document.querySelector('.product-form__quantity');
    if (qwrap) qwrap.classList.toggle('sb-hidden', st.sizesOn);
  }

  /* Called by product-form.js before the main add-to-cart request. */
  window.sbBeforeAdd = async (form, formData) => {
    const f = fieldsFor(form.getAttribute('id')); if (!f || f.dataset.apparel !== 'true') return null;
    const st = apparelState(f);
    if (st.sizesOn && !st.total) return { error: 'Enter how many pieces you need in each size.' };
    const names = optionNamesFor(st.formId), tierName = names.find((n) => /quantity/i.test(n));
    if (tierName) {
      const vars = variantsFor(st.formId) || [], idx = names.indexOf(tierName);
      const label = [...new Set(vars.map((v) => v.options[idx]))].find((l) => tierFits(l, st.total));
      const v = label && findVariant(st.formId, { ...st.opts, [tierName]: label });
      if (v) formData.set('id', v.id);
    }
    formData.set('quantity', st.total);
    const items = [], title = f.dataset.productTitle;
    const upId = +f.dataset.upchargeVariant, up = +f.dataset.upcharge || 0;
    if (st.extCount && upId && up) items.push({ id: upId, quantity: st.extCount * up, properties: { For: title, Detail: `${st.extCount} piece${st.extCount === 1 ? '' : 's'} in 2XL+ at $${up} each` } });
    const deco = Object.values(st.opts).join(' + ');
    const emb = deco.split('+').filter((p) => /embroider/i.test(p)).length;
    const reorder = f.querySelector('[data-sb-reorder]');
    const digId = +f.dataset.digitizeVariant;
    if (emb && digId && st.total < 24 && !(reorder && reorder.checked)) items.push({ id: digId, quantity: emb, properties: { For: title, Detail: `${emb} embroidered location${emb === 1 ? '' : 's'}; free at 24+ pieces` } });
    if (items.length) {
      const r = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) return { error: 'We couldn’t add the size upcharge or digitizing line. Please try again.' };
    }
    return null;
  };

  /* Price table: per-pack or per-piece prices for the current selection. */
  function renderTable(tbl) {
    const formId = tbl.dataset.form, vars = variantsFor(formId), names = optionNamesFor(formId);
    const qName = names.find((n) => /quantity/i.test(n)); if (!vars || !qName) { tbl.hidden = true; return; }
    const opts = selectedOptions(formId), qi = names.indexOf(qName);
    const rows = vars.filter((v) => names.every((n, i) => i === qi || v.options[i] === opts[n]));
    const apparel = tbl.dataset.apparel === 'true';
    tbl.querySelector('tbody').innerHTML = rows.map((v) => {
      const n = num(v.options[qi]) || 1, cur = v.options[qi] === opts[qName];
      return `<tr class="${cur ? 'sb-cur' : ''}"><td>${v.options[qi]}</td><td>${apparel ? money(v.price) + ' each' : money(v.price)}</td>${apparel ? '' : `<td>${n > 1 ? money(Math.round(v.price / n)) + ' each' : '—'}</td>`}</tr>`;
    }).join('');
  }

  /* Freight sizes (e.g. 4′ × 8′ aluminum): show the freight note and tag the cart line. */
  function syncFreight(f) {
    const sizes = (f.dataset.freight || '').split(',').map((x) => x.trim()).filter(Boolean);
    const box = f.querySelector('[data-sb-freight]'); if (!sizes.length || !box) return;
    const on = Object.values(selectedOptions(f.dataset.form)).some((v) => sizes.includes(String(v).trim()));
    box.hidden = !on;
    const prop = box.querySelector('[data-sb-freight-prop]'); if (prop) prop.disabled = !on;
  }

  /* AI design concepts: ask the Snowburd design studio (Cloudflare Worker) for 2 concepts and attach the pick. */
  let tsLoading = null;
  const loadTurnstile = () => tsLoading || (tsLoading = new Promise((resolve) => {
    if (window.turnstile) return resolve(window.turnstile);
    const s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; s.async = true;
    s.onerror = () => resolve(null); document.head.appendChild(s);
    const t = setInterval(() => { if (window.turnstile) { clearInterval(t); resolve(window.turnstile); } }, 100);
    setTimeout(() => { clearInterval(t); resolve(window.turnstile || null); }, 15000);
  }));

  function initStudio(el) {
    if (el.dataset.sbReady) return; el.dataset.sbReady = '1';
    const api = (el.dataset.api || '').replace(/\/+$/, ''), key = el.dataset.sitekey, fields = el.closest('[data-sb-fields]');
    const msg = el.querySelector('[data-sb-msg]'), grid = el.querySelector('[data-sb-grid]'), go = el.querySelector('[data-sb-go]'), out = el.querySelector('[data-sb-concept]');
    let widget = null, token = '', tsError = '';
    const say = (t) => { msg.textContent = t || ''; };
    /* Start the bot check as soon as the page loads, so a token is ready by the time the customer clicks. */
    const startCheck = async () => {
      if (!key || widget !== null) return;
      const ts = await loadTurnstile(); if (!ts) { tsError = 'script'; return; }
      widget = ts.render(el.querySelector('[data-sb-ts]'), {
        sitekey: key, size: 'flexible', appearance: 'interaction-only', 'refresh-expired': 'auto',
        callback: (t) => { token = t; tsError = ''; },
        'expired-callback': () => { token = ''; },
        'error-callback': (code) => { token = ''; tsError = String(code || 'error'); }
      });
    };
    const getToken = async () => {
      if (!key) return '';
      await startCheck();
      for (let i = 0; i < 200 && !token; i++) await new Promise((r) => setTimeout(r, 100));
      return token;
    };
    const resetToken = () => { token = ''; if (window.turnstile && widget !== null) window.turnstile.reset(widget); };
    startCheck();
    const val = (name) => { const t = fields && fields.querySelector(`[name="properties[${name}]"]`); return t ? t.value.trim() : ''; };

    go.addEventListener('click', async () => {
      const idea = val('Design idea'), wording = val('Wording');
      if (idea.length < 8 && !wording) { say('Describe your design idea or what it should say first, then try again.'); return; }
      go.disabled = true; say('Making your concepts. This takes about 15 seconds…');
      try {
        const ts = await getToken();
        const r = await fetch(api + '/concepts', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ product: el.dataset.product, idea, wording, ts }) });
        const d = await r.json().catch(() => ({}));
        resetToken();
        if (!r.ok || !d.concepts) { say((d.error || 'Concepts aren’t available right now. Describe your idea above and our designer will take it from here.') + (r.status === 403 && tsError ? ` (check code ${tsError})` : '') + (d.detail ? ` (${d.detail})` : '')); return; }
        grid.innerHTML = d.concepts.map((c, i) => `<button type="button" class="sb-concept" data-id="${c.id}" aria-pressed="false"><img src="${c.url}" alt="AI design concept ${i + 1}" loading="lazy"><span>Use concept ${i + 1}</span></button>`).join('');
        say('Pick the one closest to what you want, or try again with a different description.');
        go.textContent = 'Show me 2 more';
      } catch (e) { say('Concepts aren’t available right now. Describe your idea above and our designer will take it from here.'); }
      finally { go.disabled = false; }
    });

    grid.addEventListener('click', async (e) => {
      const b = e.target.closest('.sb-concept'); if (!b) return;
      if (b.classList.contains('is-picked')) {
        b.classList.remove('is-picked'); b.setAttribute('aria-pressed', 'false'); b.querySelector('span').textContent = b.querySelector('span').textContent.replace('Picked', 'Use');
        out.value = ''; out.disabled = true; say('No concept attached. Pick one, or leave it to our designer.'); return;
      }
      say('Saving your pick…');
      try {
        const r = await fetch(api + '/keep', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.id }) });
        const d = await r.json().catch(() => ({}));
        if (!r.ok || !d.url) { say(d.error || 'Couldn’t save that concept. Please try again.'); return; }
        grid.querySelectorAll('.sb-concept').forEach((x) => { x.classList.remove('is-picked'); x.setAttribute('aria-pressed', 'false'); const s = x.querySelector('span'); s.textContent = s.textContent.replace('Picked', 'Use'); });
        b.classList.add('is-picked'); b.setAttribute('aria-pressed', 'true'); const s = b.querySelector('span'); s.textContent = s.textContent.replace('Use', 'Picked');
        out.value = d.url; out.disabled = false;
        say('Attached to your order. Our designer will use it as the starting point for your proof.');
      } catch (err) { say('Couldn’t save that concept. Please try again.'); }
    });
  }

  function init() {
    document.querySelectorAll('[data-sb-studio]').forEach(initStudio);
    document.querySelectorAll('[data-sb-fields][data-freight]').forEach(syncFreight);
    document.querySelectorAll('[data-sb-fields]').forEach((f) => {
      if (f.dataset.apparel !== 'true' || f.dataset.sbInit) return; f.dataset.sbInit = '1';
      f.addEventListener('input', (e) => { if (e.target.matches('[data-sb-size]')) syncApparel(f); });
      document.addEventListener('change', (e) => { if (e.target.matches(`input[name="quantity"][form="${f.dataset.form}"]`)) syncApparel(f); });
      syncApparel(f);
    });
    document.querySelectorAll('[data-sb-price-table]').forEach(renderTable);
  }
  /* Quote links pass ?product= to the contact page; prefill the message. */
  function prefillQuote() {
    const p = new URLSearchParams(location.search).get('product'), body = document.getElementById('ContactForm-body');
    if (p && body && !body.value) body.value = `Quote request: ${p}\nSize:\nQuantity:\nMaterial / options:\nNeeded by:\n`;
  }
  document.addEventListener('DOMContentLoaded', () => { init(); prefillQuote(); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => {
      document.querySelectorAll('[data-sb-price-table]').forEach(renderTable);
      document.querySelectorAll('[data-sb-fields][data-apparel="true"]').forEach(syncApparel);
      document.querySelectorAll('[data-sb-fields][data-freight]').forEach(syncFreight);
      document.querySelectorAll('[data-sb-studio]').forEach(initStudio);
    }, 50));
  }
})();
